import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Theme } from '../../config/theme';
import Button from '../Button';
import TextField from '../TextField';

const CLOSE_ICON = require('./close.svg');

class MatchRequestModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setValue = this.updateTextField.bind(this);
    this.state = {
      message: '',
      charCount: 0,
    };
  }

  handleClose() {
    this.setState({
      message: '',
      charCount: 0,
    });
    this.props.onClose();
  }

  handleSubmit() {
    this.props.onSubmit(this.state.message);
    this.handleClose();
  }

  updateTextField(key, value) {
    if (key === 'message') {
      const charCount = value.length;
      if (charCount <= 500) {
        this.setState({
          message: value,
          charCount,
        });
      }
    }
  }

  render() {
    const greetingPlaceholder = this.props.ownerName ? `Hi ${this.props.ownerName}` : "Hi 'null'";

    return (
      <Modal
        isOpen={this.props.isOpen}
        className={css(styles.container)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.67)',
            zIndex: 10,
            display: 'flex',
          },
        }}
        contentLabel="Match Request"
      >
        <div className={css(styles.modal_wrapper)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.title)}>Request to share {this.props.dogName}</h2>
            <div
              className={css(styles.close_icon)}
              onClick={this.handleClose}
              role="button"
              tabIndex={0}
            >
              <img src={CLOSE_ICON} alt="Close modal" />
            </div>
          </div>
          <div className={css(styles.body)}>
            <p className={css(styles.description)}>
              Add a message to introduce yourself (optional)
            </p>
            <div className={css(styles.comments)}>
              <TextField
                textArea
                name="message"
                styles={styles.textArea}
                handler={this.setValue}
                value={this.state.message}
                placeholder={greetingPlaceholder}
              />
              <div className={css(styles.charCounter)}>{this.state.charCount} / 500</div>
            </div>

            <div className={css(styles.actions)}>
              <Button
                title="Cancel"
                theme="white"
                handler={this.handleClose}
                styles={styles.cancel_button}
              />
              <Button
                title="Send"
                theme="blue"
                handler={this.handleSubmit}
                styles={styles.submit_button}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

MatchRequestModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dogName: PropTypes.string,
  ownerName: PropTypes.string,
};

MatchRequestModal.defaultProps = {
  dogName: 'this dog',
  ownerName: 'the owner',
};

const openModalKeyFrames = {
  from: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'ease-in',
  },

  to: {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-in',
  },
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    animationName: openModalKeyFrames,
    animationDuration: '100ms',
    animationDirection: 'alternate',

    [Theme.mobile_query]: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
    },
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 60px 40px',

    [Theme.mobile_query]: {
      padding: '0px 20px 20px',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px 35px',

    [Theme.mobile_query]: {
      padding: '40px 0px 25px',
    },
  },
  title: {
    marginBottom: 0,
    fontFamily: Theme.font_family_heading,
    fontSize: 26,
    fontWeight: '900',
    textAlign: 'center',

    [Theme.mobile_query]: {
      fontSize: 22,
      paddingRight: 30,
      paddingLeft: 30,
    },
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  description: {
    marginBottom: 25,
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
    lineHeight: 1.5,
    color: '#4A4A4A',
    textAlign: 'center',
  },
  comments: {
    position: 'relative',
    width: '100%',
    marginBottom: 30,
  },
  textArea: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1,
    },
  },
  charCounter: {
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
    textAlign: 'right',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: 15,

    [Theme.mobile_query]: {
      flexDirection: 'column',
      gap: 10,
    },
  },
  cancel_button: {
    width: 150,

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  submit_button: {
    width: 150,

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
});

export default connect(null, null)(MatchRequestModal);



// WEBPACK FOOTER //
// ./src/components/MatchRequestModal/index.js